const scipYoyLevyReport = {
  label: "SCIP YOY Levy Report",
  name: "scipYoyLevyReport",
  parameters: [
    {
      name: "tax_year",
      label: "Tax year",
      type: "year",
      defaultValue: "2025",
    },
    {
      name: "county",
      label: "County",
      type: "dbfield",
      db: "scip",
      table: "County",
      keyField: "CountyId",
      valueField: "Name",
      fields: ["County.CountyId", "County.Name"],
      distinct: true,
      join: {
        Parcel: "CountyId",
      },
      sort: {
        Name: "asc",
      },
      multiple: true,
    },
  ],
};

export default scipYoyLevyReport;
